import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;

export const getInfoUpdate = (payload) => {
  return axios
    .get(`${URL_ORI}/api/InfoUpdate/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createInfoUpdate = (payload) => {
  return axios.post(`${URL_ORI}/api/InfoUpdate`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getIdInfoUpdate = (id) => {
  return axios
    .get(`${URL_ORI}/api/InfoUpdate/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateInfoUpdate = (payload) => {
  return axios.put(`${URL_ORI}/api/InfoUpdate`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateInfoUpdateStartWorkFlow = (payload) => {
  return axios
    .put(`${URL_ORI}/api/InfoUpdate/StartWorkFlow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateInfoUpdateSetStatus = (payload) => {
  return axios
    .put(`${URL_ORI}/api/InfoUpdate/setstatus`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateInfoUpdateCancel = (payload) => {
  return axios
    .put(`${URL_ORI}/api/InfoUpdate/Cancel`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateInfoUpdateConfirm = (payload) => {
  return axios
    .put(`${URL_ORI}/api/InfoUpdate/Confirm`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateInfoUpdateAmmend = (payload) => {
  return axios
    .put(`${URL_ORI}/api/InfoUpdate/ammend`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteInfoUpdate = (payload) => {
  return axios.delete(`${URL_ORI}/api/InfoUpdate`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const createInfoUpdateVehicles = (payload) => {
  return axios
    .post(`${URL_ORI}/api/InfoUpdate/addVehicles`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteInfoUpdateVehicles = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/InfoUpdate/deleteVehicles`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const createInfoUpdateParties = (payload) => {
  return axios
    .post(`${URL_ORI}/api/InfoUpdate/addParties`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const uploadInfoUpdate = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/InfoUpdate/UploadInfoUpdateVehicle?object_id=${id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const uploadInfoUpdateWorkflow = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/InfoUpdate/UploadInfoUpdateWorkFlow?object_id=${id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const uploadPicking = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/InfoUpdate/UploadPickingInfoUpdate?object_id=${id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const uploadBTS = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/InfoUpdate/UploadBackToStorageInfoUpdate?object_id=${id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// Vehicle

export const getVehicle = (payload) => {
  return axios
    .get(`${URL_ORI}/api/InfoUpdate/SearchVehiclesinInfoUpdate`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const createVehicle = (payload) => {
  return axios
    .post(`${URL_ORI}/api/InfoUpdate/AddVehicles`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateVehicle = (payload) => {
  return axios.put(`${URL_ORI}/api/Vehicle`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const deleteVehicle = (payload) => {
  return axios.delete(`${URL_ORI}/api/Vehicle`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

// party
export const getparty = (payload) => {
  return axios
    .get(`${URL_ORI}/api/InfoUpdate/searchpartyInInfoUpdate`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const createParty = (payload) => {
  return axios
    .post(`${URL_ORI}/api/InfoUpdate/AddParties`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateParty = (payload) => {
  return axios
    .put(`${URL_ORI}/api/InfoUpdate/UpdateParty`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const deleteParty = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/InfoUpdate/deleteParties`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// Generate Excel
export const getGenerateExcelBlob = (payload) => {
  return axios
    .post(
      `${URL_ORI}/api/RDM/GenerateExcel`,
      payload,
      {
        responseType: 'blob',
      }
    )
    .catch((error) => {
      if (error.response) {
        console.log(error.response, "eerorr");

        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
